const today = new Date();
const accountInitialState = localStorage.getItem('modernaPinataAccountState') ?
    JSON.parse(localStorage.getItem('modernaPinataAccountState')) :
    {
        errorLogin: false,
        isLogged: false,
        playedDate: today.getFullYear() + today.getMonth() + 1 + today.getDate(),
        playedTimes: 0,
        profile: null,
        tomorrow: today.getFullYear() + today.getMonth() + 1 + today.getDate() + 1,
        windedPrize: null
    };

export const reducerAccount = (initialState = accountInitialState, action) => {
    const state = Object.assign({}, initialState);
    const { type, payload } = action;

    switch (type) {
        case 'LOGIN':
            state.profile = payload;
            state.isLogged = true;
            break;

        case 'ERROR':
            state.errorLogin = !state.errorLogin;
            break;

        case 'LOGOUT':
            state.profile = null;
            state.isLogged = false;
            state.errorLogin = false;
            setTimeout(() => {
                localStorage.clear();
            }, 1500);
            break;

        case 'RESETDATE':
            state.playedDate = today.getFullYear() + today.getMonth() + 1 + today.getDate();
            state.tomorrow = today.getFullYear() + today.getMonth() + 1 + today.getDate() + 1;
            state.playedTimes = 0;
            break;

        case 'RESETPRIZE':
            state.windedPrize = null;
            break;

        case 'SETPRIZE':
            const { playedTimes: pTimes, playedDate: pDate, tomorrow: tDate } = state;
            if(pDate < tDate && pTimes < 5) {
                state.playedTimes = pTimes + 1;
                state.windedPrize = payload;
            } else if(pDate >= tDate) {
                state.playedDate = today.getFullYear() + today.getMonth() + 1 + today.getDate();
                state.tomorrow = today.getFullYear() + today.getMonth() + 1 + today.getDate() + 1;
                state.windedPrize = payload;
            } else {
                state.windedPrize = null;
            }
            break;

        default:
            break;
    }

    localStorage.setItem('modernaPinataAccountState', JSON.stringify(state));

    return state;
};
